var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overflow-hidden h-[100dvh] relative block"},[_c('Organism3DEnv',{ref:"3DEnv",attrs:{"data":_vm.events}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }